module.exports = __webpack_public_path__ + "img/loading.ead84d74.png";